import { render, staticRenderFns } from "./tracking-domains.vue?vue&type=template&id=ddae272a&scoped=true&"
import script from "./tracking-domains.vue?vue&type=script&lang=ts&"
export * from "./tracking-domains.vue?vue&type=script&lang=ts&"
import style0 from "./tracking-domains.vue?vue&type=style&index=0&id=ddae272a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddae272a",
  null
  
)

export default component.exports